import { memo } from 'react';

import { Link } from '../link';
import styles from './breadcrumb.module.scss';

export type BreadcrumbItem = {
  label: string;
  href?: string;
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
};

export const Breadcrumb = memo<BreadcrumbProps>(({ items }) => (
  <nav className={styles.breadcrumb} aria-label='Breadcrumb'>
    <ol className={styles.breadcrumbList}>
      {items.map((item, index) => (
        <li key={index} className={styles.breadcrumbItem}>
          {index < items.length - 1 ? (
            <>
              {item.href ? (
                <Link to={item.href}>{item.label}</Link>
              ) : (
                <span className={styles.breadcrumbText}>{item.label}</span>
              )}
              <span className={styles.separator}>/</span>
            </>
          ) : (
            <span className={styles.breadcrumbText} aria-current='page'>
              {item.label}
            </span>
          )}
        </li>
      ))}
    </ol>
  </nav>
));
